import { AboutItem } from 'models'

export const defaultaboutProject: AboutItem = {
  title: '',
  text: ''
}
